import type { APIPublicGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import { defaultGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import { getNameColour } from "./getNameColour.js";
import { Permission } from "@rosette/ts/src/business/role/Permission.js";
import type { Role } from "@rosette/ts/src/business/role/Role.js";
import type { ReactNode } from "react";


interface DisplayNameProps {
    className?: string;
    name: string | ReactNode;
    preferences: APIPublicGamePreferences | null;
    roles: Role[];
}


export function DisplayName({ className, name, preferences, roles }: DisplayNameProps) {
    preferences ??= defaultGamePreferences;

    let nameColour = preferences.nameColour;
    if (!Permission.NAME_COLOURS.hasPermission(roles)) {
        nameColour = "gray";
    }
    return (
        <span
            className={className}
            style={{ color: getNameColour(nameColour).colorCSS }}>

            {name}
        </span>
    );
}
